import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "800",
  height: "800",
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M5.213 4.59A2 2 0 1 0 3 4.732v6.536A2 2 0 0 0 4 15a2 2 0 0 0 1-3.732V8.292a7.982 7.982 0 0 0 5.248 2.673 2 2 0 1 0 .044-2.006A6.006 6.006 0 0 1 5.213 4.59Z"
    }, null, -1)
  ]))]))
}
export default { render };